
























































































































































































import { Component, Prop, Vue } from "vue-property-decorator";

interface Post {
  uid: string
  title: string
  content: string
  createdAt: string
  tags: Array<string>
  image: string
}

interface Description {
  id: string;
  title: string;
  descriptions: Array<Td>;
}
interface Td {
  id: string;
  title: string;
  images: Array<Image>;
  items: Array<string>;
  pres: Array<Pre>;
}

interface Image {
  src: string;
  comment: string;
}
interface Pre {
  src: string;
  comment: string;
}

@Component
export default class GolangComponent extends Vue {
  @Prop()
	private msg!: string;
	private signinStatus = "signed out"
  
	private isActive = "1"

  private uid: string = '?'
  private title: string = '?'
  private content: string = '?'
  private createdAt: string = '?'
  private tags: Array<string> = ['?']
  private image: string = '?'
  
  //private posts: Array<string> = ['AnAKLGcDD8fpYwD1UQhl', 'FvT2sbUSkSASF978fcAw', 'a9FWwIqt4nXdrUfVfssU']
  private posts: Array<Post> = []

  private postIndex = 0
  
  //private posts:Array<Post> = [Post?]

	created() {
		const user = this.$auth.currentUser
		if (user) {
			// User is signed in.
			const email = user.email
			const uid = user.uid
			this.signinStatus = "signed in"
			//window.console.log("created() 2.User is signed in: ")
			//window.console.log("created() 3.uid: " + uid)
			//window.console.log("created() 4.email: " + email)
		} else {
			// No user is signed in.
			this.signinStatus = "signed out"
			window.console.log("created() 5.No user is signed in: ")
			// 単純な遷移
			//this.$router.push('/signin/')
		}
	}

    /*
	private text1 = `
	import (
	  "fmt"
	  "context"

	  firebase "firebase.google.com/go"
	  "firebase.google.com/go/auth"

	  "google.golang.org/api/option"
	)

	func main() {
	    opt := option.WithCredentialsFile("xxxx.json")
	    ctx := context.Background()
	    app, err := firebase.NewApp(ctx, nil, opt)
	    if err != nil {
	        fmt.Errorf("error initializing app: %v", err)
	    }
	    client, err := app.Firestore(ctx)
	    if err != nil {
	        fmt.Errorf("error initializing client: %v", err)
	    }
	    defer client.Close()
	    fmt.Println("Firestore connection done")
	}
	`
	private text2 = `
	package main

	import (
	    "fmt"

	    "golang.org/x/net/context"

	    firebase "firebase.google.com/go"
	    "google.golang.org/api/option"
	)

	func main() {
	    // クライアント接続
	    opt := option.WithCredentialsFile("key.json")
	    ctx := context.Background()
	    app, err := firebase.NewApp(ctx, nil, opt)
	    if err != nil {
	        fmt.Errorf("error initializing app: %v", err)
	    }
	    client, err := app.Firestore(ctx)
	    if err != nil {
	        fmt.Errorf("error initializing client: %v", err)
	    }
	    defer client.Close()
	    fmt.Println("Connection done")

	    // 値の取得
	    collection := client.Collection("コレクションID")
	    doc := collection.Doc("ドキュメントID")
	    field, err := doc.Get(ctx)
	    if err != nil {
	        fmt.Errorf("error get data: %v", err)
	    }
	    data := field.Data()
	    for key, value := range data {
	        fmt.Printf("key: %v, value: %v\\n", key, value)
	    }
	}	
	`
	*/
	
	private text3 = `
	type Mixer struct {
		streamers []Streamer
	}
	`
	private text4 = `
	// Streamer is able to stream a finite or infinite sequence of audio samples.
	type Streamer interface {
		// Stream copies at most len(samples) next audio samples to the samples slice.
		//
		// The sample rate of the samples is unspecified in general, but should be specified for
		// each concrete Streamer.
		//
		// The value at samples[i][0] is the value of the left channel of the i-th sample.
		// Similarly, samples[i][1] is the value of the right channel of the i-th sample.
		//
		// Stream returns the number of streamed samples. If the Streamer is drained and no more
		// samples will be produced, it returns 0 and false. Stream must not touch any samples
		// outside samples[:n].
		//
		// There are 3 valid return pattterns of the Stream method:
		//
		//   1. n == len(samples) && ok
		//
		// Stream streamed all of the requested samples. Cases 1, 2 and 3 may occur in the following
		// calls.
		//
		//   2. 0 < n && n < len(samples) && ok
		//
		// Stream streamed n samples and drained the Streamer. Only case 3 may occur in the
		// following calls.
		//
		//   3. n == 0 && !ok
		//
		// The Streamer is drained and no more samples will come. If Err returns a non-nil error, only
		// this case is valid. Only this case may occur in the following calls.
		Stream(samples [][2]float64) (n int, ok bool)

		// Err returns an error which occurred during streaming. If no error occurred, nil is
		// returned.
		//
		// When an error occurs, Streamer must become drained and Stream must return 0, false
		// forever.
		//
		// The reason why Stream doesn't return an error is that it dramatically simplifies
		// programming with Streamer. It's not very important to catch the error right when it
		// happens.
		Err() error
	}
	`

	private contents1: Description = {
		id: "1",
		title: "「Flutter2」の概要",
		descriptions: [
		 {id: "1",
		  title: "単一コードでiOS/Android/Web/Win/Mac/Linuxのネイティブアプリ実現",
		  images: [
		    { src: "https://www.publickey1.jp/2021/flutter201.gif",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"Googleは、2021年3月8日にDart言語のフレームワーク「Flutter 2」の公開を発表しました。",
		  	"Flutter 2では、Webアプリケーション開発機能が安定版となり、さらにWindows、Mac、Linux対応のアプリケーション開発も早期リリースフラグ付きの安定版になりました。",
		  	"これによりFlutter 2は、単一のコードベースでiOS、Androidのネイティブなモバイルアプリケーション、Windows、Mac、Linuxのネイティブなデスクトップアプリケーション、Webアプリケーション、そして組み込みデバイスのアプリケーションまで生成できる、マルチプラットフォームのアプリケーション開発に対応するフレームワークとなりました。",
		    ],
		  pres: [],
		 }, // end of id=1
		 {id: "2",
		  title: "WebAssemblyによる高速なレンダリングエンジン搭載",
		  images: [
		    { src: "//www.publickey1.jp/2021/flutter203.gif",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"そして今回、リリースが発表された「Flutter 2」では、Webアプリケーション対応が安定版となりました。",
		  	"Webアプリケーション対応では、WebAssemblyによる高速なレンダリングエンジン「CanvasKit」を搭載することで、ネイティブアプリケーションのように柔軟なグラフィックとUIを実現しています。",
		  	"SPA（Single Page Application）やPWA（Progressive Web Application）などの開発にも対応します。",
		  	"下記はお掃除ロボットのルンバで知られるiRobot社がFlutterで開発した教育向けプログラミング環境のWebアプリケーション画面です。",
		    ],
		  pres: [],
		 }, // end of id=2
		 {id: "3",
		  title: "トヨタが車載システムにFlutterを採用",
		  images: [
		    { src: "//www.publickey1.jp/2021/flutter205.gif",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"さらにFlutter 2は組み込み機器への対応も始めており、トヨタが新しい自動車向けのインフォテイメントシステム（インフォメーション＋エンターテイメント）の開発にFlutter 2を採用したことが発表されました。",
		    ],
		  pres: [],
		 }, // end of id=3

		]
	} // end of contents1


	private text5 = `
import 'dart:async';

final streamController = StreamController<String>();

void main() async {
  streamController.stream.listen((addData){
    print(addData);
  });

  print("ザ・ワールド！！");
  streamController.sink.add("DIO");
  print("スタープラチナ！！");
  streamController.sink.add("承太郎");
  print("ハイエロファントグリーン！！");
  streamController.sink.add("花京院");
}
`
	private text6 = `
# 出力結果
flutter: ザ・ワールド！！
flutter: スタープラチナ！！
flutter: ハイエロファントグリーン！！
flutter: DIO
flutter: 承太郎
flutter: 花京院
`
	private text7 = `
// ChangeNotifierを継承しない例
class CountData {
  int count = 0;
}

class ParentWidget extends StatelessWidget {
  @override
  Widget build(BuildContext context) {
    // Provider<T>() で子Widgetにデータを渡す
    // ※ 渡すデータの クラス と <T> は揃えましょう
    return Provider<CountData>.value(
      // 渡すデータ
      create: (context) => CountData(),
      child: Container(
        child: ChildWidget(),
      ),
    );
  }
}

class ChildWidget extends StatelessWidget {
  @override
  Widget build(BuildContext context) {
    // Provider.of<T>(context) で親Widgetからデータを受け取る
    // ※ 受け取るデータの クラス と <T> は揃えましょう
    final CountData data = Provider.of<CountData>(context);

    return Column(
      children: <Widget>[
        // 受け取ったデータを使いUI作成
        Text('count is ＄{data.count.toString()}'),
      ],
    );
  }
}
`
	private text8 = `
// ChangeNotifierを継承すると変更可能なデータを渡せる
class CountData extends ChangeNotifier {
  int count = 0;

  void increment() {
    count = count + 1;
    // 値が変更したことを知らせる
    //  >> UIを再構築する
    notifyListeners();
  }
}

class ParentWidget extends StatelessWidget {
  @override
  Widget build(BuildContext context) {
    // Provider<T>() で子Widgetにデータを渡す
    // ※ 渡すデータの クラス と <T> は揃えましょう
    return ChangeNotifierProvider<CountData>(
      // 渡すデータ
      create: (context) => CountData(),
      child: Container(
        child: ChildWidget(),
      ),
    );
  }
}

class ChildWidget extends StatelessWidget {
  @override
  Widget build(BuildContext context) {
    // Provider.of<T>(context) で親Widgetからデータを受け取る
    // ※ 受け取るデータの クラス と <T> は揃えましょう
    final CountData data = Provider.of<CountData>(context);

    return Column(
      children: <Widget>[
        // 受け取ったデータを使いUI作成
        Text('count is ＄{data.count.toString()}'),
        ElevatedButton(
          child: Text('Increment'),
          onPressed: () {
            // データを更新
            data.increment();
          },
        ),
      ],
    );
  }
}
`

	private contents2: Description = {
		id: "2",
		title: "BLoC(Business Logic Component)",
		descriptions: [
		 {id: "1",
		  title: "BLoC(Business Logic Component)とは",
		  images: [
		    { src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/bloc_1.jpg?alt=media",
		  	  comment: "BLoCのイメージ",
		    },
		  ],
		  items: [
		  	"ビジネスロジックを切り出して再利用・修正などをしやすくするためのコンポーネントであり、状態管理に関するアーキテクチャパターンです。",
			"https://youtu.be/PLHln7wHgPE?t=1438 より、以下のルールに従うものがBLoCであるとされています。",
		  	"①BLoCの入出力はStream/Sinkを使う。",
			"②BLoCの依存は必ず注入可能でプラットフォームに依存しない。",
			"③BLoC内にプラットフォームごとの分岐処理は書いてはいけない。",
		  ],
		  pres: [],
		 }, // end of id=1
		 {id: "2",
		  title: "Stream/Sinkとは",
		  images: [
		    { src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/bloc_2.jpg?alt=media",
		  	  comment: "Stream/Sinkのイメージ",
		    },
		  ],
		  items: [
		  	"多分、ここの理解はStreamのざっくりとしたイメージを見た方が分かりやすいかと思いました。(桃太郎をイメージしています。)",
			"先ほどのaddしないとlistenが動かないということを桃太郎流に解説すると、そもそも川に対して桃を流して(sink.add)あげないとおばあさんは桃を拾う(stream.listen)ことが出来ませんよね。ということになります。",
		  	"以下の例は、「StreamController」を使用して、「sink.add」処理と「stream.listen」処理を行っている例です。",
		  ],
		  pres: [{src: this.text5, comment: "「StreamController」を使用して、「sink.add」処理と「stream.listen」処理例"}, {src: this.text6, comment: "出力例"},],
		 }, // end of id=1
		]
	} // end of contents2

	private contents3: Description = {
		id: "3",
		title: "Dialogflow CX",
		descriptions: [
		 {id: "1",
		  title: "エージェント",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"Dialogflow CX エージェントは、エンドユーザーとの会話を処理する仮想エージェントです。",
		  	"これは、人間の言語のニュアンスを理解する自然言語理解モジュールです。",
		  	"Dialogflow は、会話中のエンドユーザーのテキストまたは音声をアプリやサービスが理解できる構造化データに変換します。",
		  	".",
		  	"Dialogflow エージェントは、システムに必要な種類の会話が処理されるように設計および構築されます。",
		  	"Dialogflow エージェントは、人間のコールセンター エージェントに似ています。",
		  	"予想される会話のシナリオに対処するためにトレーニングを行ってください。",
		  	"ただし、トレーニングを過度に行う必要はありません。",
		  ],
		  pres: [],
		 }, // end of id=1
		 {id: "2",
		  title: "フロー",
		  images: [
		    { src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/cx-flow.svg?alt=media",
		  	  comment: "ピザの配達エージェントのフロー",
		    },
		  ],
		  items: [
		  	"多くの場合、複雑なダイアログでは複数の会話トピックが関与します。",
		  	"たとえば、ピザの配達エージェントの場合、料理の注文、顧客情報、確認という別個のトピックが考えられます。",
		  	"各トピックでは、エージェントがエンドユーザーから関連する情報を取得するため、複数の会話ターンを実行する必要があります。",
		  	".",
		  	"フローは、これらのトピックと、関連する会話パスを定義するために使用されます。",
		  	"すべてのエージェントには、デフォルトの開始フローと呼ばれるフローが 1 つあります。",
		  	"単純なエージェントであれば、このフローのみで十分でしょう。",
		  	"より複雑なエージェントでは追加のフローが必要になる場合があります。",
		  	"さまざまな開発チームのメンバーに、これらのフローの構築と保守を担当させることができます。",
		  	"たとえば、ピザの配達エージェントのフローは次のようになります。",
		  	".",
		  	"Dialogflow CX のフローは、Dialogflow ES メガ エージェントのサブエージェントと同様の目的で機能します。",
		  	"フローを使用すると会話をより適切に制御できます。",
		  	"追加のコストは発生しません。",
		  ],
		  pres: [],
		 }, // end of id=2
		 {id: "3",
		  title: "ページ",
		  images: [
		    { src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/cx-page.svg?alt=media",
		  	  comment: "ピザ宅配業者の Food Order フローのページ（青で表示）",
		    },
		  ],
		  items: [
		  	"Dialogflow CX の会話（セッション）は、ステートマシンとして記述し、可視化できます。",
		  	"CX セッションの状態はページで表されます。",
		  	".",
		  	"フローごとに多数のページを定義します。",
		  	"結合されたページでは、フローが設計されたトピックに関する完全な会話を処理できます。",
		  	"どの時点でも、正確に 1 つのページが現在のページであり、また現在のページがアクティブで、そのページに関連付けられたフローもアクティブであるとみなされます。",
		  	"すべてのフローには特別なスタートページがあります。",
		  	"フローが最初にアクティブになると、スタートページが現在のページになります。",
		  	"会話の各ターンでは、現在のページがそのまま表示されるか、別のページに遷移します。",
		  	".",
		  	"各ページを、そのページが表す会話の状態に関連するエンドユーザーから情報を収集するように構成します。",
		  	"たとえば、次の図にピザ宅配業者の Food Order フローのページ（青で表示）作成します。",
		  	"図の Start ノードは Food Order フローの開始ページを表します。",
		  	"フローが完了すると、Confirmation フローに遷移します。",
		  ],
		  pres: [],
		 }, // end of id=3
		 {id: "4",
		  title: "エンティティ型",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"エンティティ タイプを使用して、エンドユーザー入力からデータを抽出する方法を制御します。",
		  	"CX エンティティ タイプは、ES エンティティ タイプとよく似ています。",
		  	".",
		  	"Dialogflow では、多数の一般的なタイプのデータに対応する事前定義のシステム エンティティが用意されています。",
		  	"たとえば、日付、時刻、色、メールアドレスなどを照合するシステム エンティティがあります。",
		  	"カスタムデータを一致させる独自のカスタム エンティティを作成することもできます。",
		  	"たとえば、食料品店エージェントで購入可能な野菜の種類に一致する野菜エンティティを定義できます。",
		  ],
		  pres: [],
		 }, // end of id=4
		 {id: "5",
		  title: "パラメータ",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"パラメータは、セッション中にエンドユーザーが指定した値を取得して参照するために使用されます。",
		  	"各パラメータには名前とエンティティ タイプがあります。",
		  	"未加工のエンドユーザー入力とは異なり、パラメータは、ロジックの実行やレスポンスの生成に簡単に使用できる構造化データです。",
		  	".",
		  	"CX パラメータは、ES パラメータと似ていますが、ユーティリティとスコープが拡張され、パラメータを参照する構文が異なります。",
		  ],
		  pres: [],
		 }, // end of id=5
		 {id: "6",
		  title: "フォーム",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"ページごとにフォームを定義できます。",
		  	"これは、ページのエンドユーザーから収集する必要があるパラメータのリストです。",
		  	"エージェントは、必要なすべてのフォーム パラメータ（ページ パラメータとも呼ばれます）を収集するまで、複数の会話ターンでエンドユーザーとやり取りします。",
		  	"フォーム パラメータごとに、エージェントがエンドユーザーからの情報をリクエストするために使用するプロンプトも表示します。",
		  	"このプロセスをフォーム入力と呼びます。",
		  	".",
		  	"たとえば、Collect Customer Info ページのエンドユーザーの名前と電話番号を収集するフォームを作成できます。",
		  	".",
		  	"CX フォームの入力は、ES スロットの入力に似ています。",
		  ],
		  pres: [],
		 }, // end of id=6

		]
	} // end of contents3

	private contents4: Description = {
		id: "4",
		title: "Provider",
		descriptions: [
		 {id: "1",
		  title: "Providerとは何か",
		  images: [
		    { src: "",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"StatefulWidget と State を使えば状態を元にUIを作ることは可能です。",
		  	"ですが、様々なWidgetが組み合わさったUIになり、状態が複雑になってしまうと、管理しきれなくなってしまうのです。",
		  	"そこで、登場するのが provider です。",
		  	"https://pub.dev/packages/provide",
		  	"これを使うことで複雑な状態も簡単に管理することができるのです。",
		  ],
		  pres: [],
		 }, // end of id=1
		 {id: "2",
		  title: "Providerの使い方",
		  images: [
		    { src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/provider-state.svg?alt=media",
		  	  comment: "親Widgetから子Widgetにデータを受け渡す",
		    },
		  ],
		  items: [
		  	"・Providerで出来ること",
		  	"では、Providerを使うと具体的には何が出来るのでしょうか？",
		  	"とてもシンプルで親Widgetから子Widgetにデータを受け渡すことが出来るのです。",
		  	"データを渡す先は、子Widgetであれば何処でもOKです。",
		  	"・データの受け渡し",
		  	"Providerの基本的なデータの受け渡し方法を確認していきましょう。",
		  	"使い方は簡単で、親Widgetと子Widgetでデータの受け渡し用の処理を追加するだけで良いのです。",
		  	"解説",
		  	"親Widgetで Provider<T>.value() を使いデータを渡す",
		  	"子Widgetで Provider.of<T>() を使いデータを受け取る",
		  	".",
		  	"・受け渡すデータを更新する",
		  	"受け渡すデータを更新する方法も確認していきましょう。",
		  	"こちらも難しいことはなく、",
		  	"ChangeNotifier を継承したデータを ChangeNotifierProvider を使って渡せば良いのです。",
		  	"解説",
		  	"受け渡すデータは ChangeNotifier を継承し notifyListeners() を使って変更を知らせる",
		  	"ChangeNotifierProvider を使ってデータを渡す",
		  	".",
		  ],
		  pres: [
		  	{src: this.text7, comment: "ソースコードの例（ChangeNotifierを継承しない例）"},
		  	{src: this.text8, comment: "ソースコードの例（ChangeNotifierを継承する例）"},
		  	],
		 }, // end of id=2
		 {id: "3",
		  title: "簡単なチャットアプリでProviderを使用する",
		  images: [
		    { src: "https://firebasestorage.googleapis.com/v0/b/helloapp-87353.appspot.com/o/about-firebase-app.svg?alt=media",
		  	  comment: "チャットアプリのイメージ図",
		    },
		  ],
		  items: [
		  	"Firebaseコンソールへログイン",
		  	"「設定」→「プロジェクトの設定」で設定画面を表示",
		  	"「サービスアカウント」タブを押し、Firebase Admin SDKを表示する",
		  	"Admin SDK 構成スニペットでGoを選択",
		  	"【新しい秘密鍵の生成】ボタンから秘密鍵(json)をダウンロード",
		  ],
		  pres: [],
		 }, // end of id=3
		]
	} // end of contents4

	private contents5: Description = {
		id: "5",
		title: "Firestore",
		descriptions: [
		 {id: "1",
		  title: "「Go言語」で音声を利用する",
		  images: [
		    { src: "about-firebase-app",
		  	  comment: "",
		    },
		  ],
		  items: [
		  	"Mixer構造体：Streamerの配列です。",
		  	"Streamerインタフェース：Stream()関数を持ちます。",
		  	"Stream()関数：Sample([][2]float64)を返します。",
		  ],
		  pres: [
		   {src: this.text3, comment: "①Mixer構造体の定義"},
		   {src: this.text4, comment: "②Streamerインタフェースの定義"},
		  ],
		 }, // end of id=1
		]
	} // end of contents4

} // end of export
